module.exports = __webpack_public_path__ + "media/application/images/unesco-blue@2x-613b08ff88f60a7e5555afda8823654586bd235fe1af2b5f54724d117c3d7b75.png";